<div>
    <div class="row" *ngIf="getSelectedRowData() && status === 'Draft'">
        <div class="pull-right col-md" >
            <span class="pull-right button small -primary m-2" (click)="deleteSelectedRows()">{{'LITERATURE.REVIEW.DELETEROW' | translate }}</span> 
            <span class="pull-right button small -primary m-2" (click)="copyRows()">{{'LITERATURE.REVIEW.DUPLICATEROW' | translate }}</span> 
            <span class="pull-right button small -primary m-2" (click)="connectToDifferentPar()">{{'LITERATURE.REVIEW.CHANGEKEYQUESTION' | translate }}</span> 
        </div>
    </div>
    <div class="row" *ngIf="getSelectedRowData() && status === 'Current'">
        <div class="pull-right col-md" >
            <span class="pull-right button small -primary m-2" (click)="createDraft()">{{'LITERATURE.REVIEW.evidenceTableActions' | translate }}</span> 
        </div>
    </div>
     <ag-grid-angular
        #agGrid
        style="width: 100%"
        class="ag-theme-alpine"
        [columnDefs]="columnDefs"
        [immutableData]="true"
        [defaultColDef]="defaultColDef"
        [rowData]="rowData"
        [frameworkComponents]="frameworkComponents"
        domLayout='autoHeight'
        singleClickEdit="true" 
        (selectionChanged)="getSelectedRowData()"
        rowHeight='150'
        rowSelection='multiple'
        suppressRowClickSelection='true'
        (eventBus)="handleEventBus($event)"
        [getRowNodeId]="getRowNodeId"
    >
    </ag-grid-angular>
</div>


